module.exports = __webpack_public_path__ + "img/sankaku_14_red.9b774b0e.png";